import { render, staticRenderFns } from "./RadioCheckboxConfigView.vue?vue&type=template&id=086d1699&scoped=true"
import script from "./RadioCheckboxConfigView.vue?vue&type=script&lang=js"
export * from "./RadioCheckboxConfigView.vue?vue&type=script&lang=js"
import style0 from "./RadioCheckboxConfigView.vue?vue&type=style&index=0&id=086d1699&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086d1699",
  null
  
)

export default component.exports